import {uploadSvg as Icon__small__uploadSvg} from '../Icon__small/Icon__small--upload.js';

export var upload = {
  name: 'upload',
  category: 'icon',
  colorable: true,
  svg: Icon__small__uploadSvg,
};
